// extracted by LIB_CSS_EXTRACT_LOADER
import "./timeline_module.css"
export default {"timeline":"timeline-aElsjt","item":"item-Seqg42","dot":"dot-SJ1JR5","content":"content-GlRR36"};